import { Badge, Popover } from '@material-ui/core';
import NotificationsIcon from '@material-ui/icons/Notifications';
import CustomIconButton from 'components/CustomInput/IconButton';
import React, { useState, useRef } from 'react';
import styled from 'styled-components/macro';
// import SettingsIcon from '@material-ui/icons/Settings';
import TextHeader from 'components/CustomText/TextHeader';
import { useSelector } from 'react-redux';
import TextSubHeader from 'components/CustomText/TextSubHeader';
// import { getNotificationData } from 'sampleData/notificationData';
// import { produce } from 'utility/general';
import { useDispatch } from 'react-redux';
import moment from 'moment';
import { useHistory } from 'react-router';
import { FETCH_NOTIFICATION_ALL_LIST, FETCH_NOTIFICATION_MARK_READ, SET_NOTIFICATION } from 'store/key';
import useTouchBottom from 'hooks/useTouchBottom';
import { makeStyles } from '@material-ui/core/styles';
import LoadingIndicator from 'components/LoadingIndicator';
import {
    INIT_APPLICATION,
    AMENDMENT_FORM,
    SUSAR_REPORT,
    MISCELLANEOUS_REPORT,
    FINAL_REPORT,
    CTC,
    CTI,
    PROGRESS_REPORT,
    PROTOCOL_DEVIATION_REPORT,
    LOCAL_SAE_REPORT,
} from 'utility/postApprovalLookUp';

import { getNotificationCountOfUnread } from 'utility/general';
import { setItem } from 'storage';
import { KEY_PATHNAME } from 'utility/lookup';
const SLayout = styled.span``;

const SNotificationLayout = styled.div``;

const SHeader = styled.div`
    display: flex;
    padding: 10px;
    align-items: center;
    justify-content: space-between;
    position: relative;
    border-bottom: 1px solid #dcdcdc;
`;

const SCenter = styled.div`
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
`;

const SEmptyLayout = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    height: 300px;
    width: 500px;
`;

const SItem = styled.div`
    padding: 20px 10px 10px 20px;
    /* display: flex; */
    position: relative;
    /* flex-direction: column; */
`;

const SContent = styled.div`
    height: 450px;
    width: 500px;
    overflow-y: auto;
`;

const SMessage = styled.div`
    margin-top: 8px;
    font-size: 14px;
`;

const SBottomDivider = styled.div`
    position: absolute;
    bottom: 0;
    left: 20px;
    right: 10px;
    border-bottom: 1px solid #dcdcdc;
`;

const SUnReadLine = styled.div`
    position: absolute;
    left: 0;
    top: 2px;
    bottom: 2px;
    border-left: 4px solid #0087f5;
    border-radius: 5px;
`;

const SInfoLayout = styled.div`
    display: flex;
    justify-content: space-between;
`;
const useStyles = makeStyles((theme) => ({
    end: {
        // padding: '20px 10px 10px 20px',
        height: '1px',
        backgroundColor: '#dcdcdc',
        margin: '19px 10px 10px 20px',
        position: 'relative',
        '& span': {
            position: 'absolute',
            top: '-9px',
            left: '50%',
            padding: '0 10px',
            backgroundColor: '#fff',
            marginLeft: '-15px',
        },
    },
}));

const NotificationButton = (props) => {
    const [anchorEl, setAnchorEl] = useState(null);
    const [loading, setLoading] = useState(false);
    const [emptyLoading, setEmptyLoading] = useState(false);
    const dispatch = useDispatch();
    const history = useHistory();
    // const previousElement = usePrevious(anchorEl);

    const NOT_REDIRECT = [-1];
    const NOTIFICATION_REDIRECT = {
        [NOT_REDIRECT]: null,
        [INIT_APPLICATION]: '/applications/initial-application-form?id=',
        [AMENDMENT_FORM]: '/post-approval-document/application-amendment-detail?id=',
        [CTC]: '/view-ctc?reportId=',
        [CTI]: '/view-cti?reportId=',
        [SUSAR_REPORT]: '/SUSAR-report?reportId=',
        [MISCELLANEOUS_REPORT]: '/miscellaneous-report?reportId=',
        [FINAL_REPORT]: '/final-report?reportId=',
        [PROGRESS_REPORT]: '/progress-report?reportId=',
        [PROTOCOL_DEVIATION_REPORT]: '/protocol-deviation?reportId=',
        [LOCAL_SAE_REPORT]: '/SAE-report?reportId=',
    };

    const { notificationList, unReadCount, page, hasNext } = useSelector((state) => ({
        notificationList: state.notification.list,
        unReadCount: state.notification.unReadCount,
        page: state.notification.page,
        hasNext: state.notification.hasNext,
    }));

    const onClick = (e) => {
        setEmptyLoading(true);
        getNotificationList();
        setAnchorEl(e.currentTarget);

        setTimeout(() => {
            getNotificationCountOfUnread();
        }, 100);
    };

    const onClose = () => {
        setAnchorEl(null);
        setTimeout(() => {
            dispatch({
                type: SET_NOTIFICATION,
                payload: {
                    page: 0,
                    list: [],
                    hasNext: true,
                },
            });
        }, 500);
    };

    const getNotificationList = () => {
        if (!hasNext) return;
        setLoading(true);
        dispatch({
            type: FETCH_NOTIFICATION_ALL_LIST,
            payload: {
                callback: () => {
                    setLoading(false);
                    setEmptyLoading(false);
                },
            },
        });
    };

    const postNotificationMarkRead = (id, markAll, index) => {
        dispatch({
            type: FETCH_NOTIFICATION_MARK_READ,
            payload: {
                id,
                markAll,
                index,
            },
        });
    };

    const updateRead = () => {
        if (unReadCount) {
            postNotificationMarkRead(null, true, null);
        }
    };

    const handleMarkRead = (item, index) => {
        if (!item.read) {
            postNotificationMarkRead(item.id, false, index);
        }
    };

    const onClickMsg = (item, index) => {
        if (
            [
                INIT_APPLICATION,
                AMENDMENT_FORM,
                SUSAR_REPORT,
                MISCELLANEOUS_REPORT,
                FINAL_REPORT,
                CTC,
                CTI,
                PROGRESS_REPORT,
                PROTOCOL_DEVIATION_REPORT,
                LOCAL_SAE_REPORT,
            ].includes(item.type)
        ) {
            setItem(KEY_PATHNAME, '/');
        }

        if (![null, undefined].includes(NOTIFICATION_REDIRECT[item.type])) {
            history.push(NOTIFICATION_REDIRECT[item.type] + item.linkId);
        }
        if (!item.read) {
            handleMarkRead(item, index);
            // postNotificationMarkRead(item.id, false);
        }
    };
    return (
        <SLayout>
            <CustomIconButton onClick={onClick} style={{ color: '#fff', padding: 10 }}>
                <Badge max={999} badgeContent={unReadCount} color={'secondary'}>
                    <NotificationsIcon fontSize={'small'} />
                </Badge>
            </CustomIconButton>

            <Popover
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'center',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'center',
                }}
                anchorEl={anchorEl}
                open={!!anchorEl}
                disableRestoreFocus
                disableScrollLock={false}
                onClose={onClose}
            >
                <SNotificationLayout>
                    <SHeader>
                        <div>{/* <SettingsIcon /> */}</div>
                        <SCenter>
                            <TextHeader>Notification</TextHeader>
                        </SCenter>
                        <div style={{ fontSize: 14, cursor: 'pointer', color: 'blue' }} onClick={updateRead}>
                            Mark All As Read
                        </div>
                    </SHeader>
                    {(notificationList?.length ?? 0) === 0 ? (
                        <SEmptyLayout>
                            {!emptyLoading && <TextSubHeader>No notification</TextSubHeader>}
                            {emptyLoading && <LoadingIndicator />}
                        </SEmptyLayout>
                    ) : (
                        <NotificationContent
                            notificationList={notificationList}
                            NOTIFICATION_REDIRECT={NOTIFICATION_REDIRECT}
                            page={page}
                            hasNext={hasNext}
                            loading={loading}
                            onClickMsg={onClickMsg}
                            handleMarkRead={handleMarkRead}
                            getNotificationList={getNotificationList}
                        />
                    )}
                </SNotificationLayout>
            </Popover>
        </SLayout>
    );
};
const NotificationContent = ({
    notificationList,
    NOTIFICATION_REDIRECT,
    onClickMsg,
    handleMarkRead,
    hasNext,
    getNotificationList,
    loading,
}) => {
    const boxRef = useRef(null);
    const classes = useStyles();
    const getList = () => {
        if (hasNext) {
            getNotificationList();
        }
    };
    useTouchBottom({ callback: getList, boxRef });
    const msgContentStyle = (item) => {
        const clickStyle =
            ![null, undefined].includes(NOTIFICATION_REDIRECT[item.type]) || !item.read ? { cursor: 'pointer' } : {};
        const colorStyle = ![null, undefined].includes(NOTIFICATION_REDIRECT[item.type]) ? { color: 'blue' } : {};
        return {
            ...clickStyle,
            ...colorStyle,
            wordBreak: 'break-all',
        };
    };
    return (
        <SContent ref={boxRef}>
            {notificationList?.map((item, index) => {
                return (
                    <SItem key={`${index}${item.content}`}>
                        <SInfoLayout>
                            <TextSubHeader>From: {item.fromUser}</TextSubHeader>
                            <div style={{ fontSize: 12, textDecoration: 'italic' }}>
                                {moment(item.createDtm).format('YYYY-MM-DD HH:mm:ss')}
                            </div>
                        </SInfoLayout>
                        <SMessage
                            style={msgContentStyle(item)}
                            onClick={() => {
                                onClickMsg(item, index);
                            }}
                        >
                            <pre
                                style={{
                                    whiteSpace: 'break-spaces',
                                }}
                            >
                                {item.content}
                            </pre>
                        </SMessage>
                        <div style={{ textAlign: 'end', paddingTop: 5 }}>
                            {!item.read && (
                                <span
                                    onClick={() => {
                                        handleMarkRead(item, index);
                                    }}
                                    style={{ fontSize: 14, cursor: 'pointer', color: 'blue' }}
                                >
                                    Mark As Read
                                </span>
                            )}
                        </div>
                        <SBottomDivider />
                        {!item.read && <SUnReadLine />}
                    </SItem>
                );
            })}
            {hasNext && loading && <LoadingIndicator style={{ padding: '10px' }} size={20} />}
            {!hasNext && (
                <div className={classes.end}>
                    <span>End</span>
                </div>
            )}
        </SContent>
    );
};
export default NotificationButton;
